import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const locale = "sr";

export const noteTypesManagement = createApi({
    reducerPath: "noteTypesManagement",
    baseQuery: fetchBaseQuery({
        baseUrl: `${BASE_URL}`,
        prepareHeaders: (headers) => {
            const jwtToken = localStorage.getItem("userToken") || sessionStorage.getItem("userToken");

            if (jwtToken) {
                headers.set("authorization", `Bearer ${jwtToken}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        noteTypesList: builder.mutation({
            query: (body) => {
                let url = `v1/${locale}/settings/note-types`;

                for (const property in body) {
                    if ((property && body[property]) || (property === "startPage" && body[property] === 0)) {
                        if (url?.includes("?")) {
                            url += `&${property}=${body[property]}`;
                        } else {
                            url += `?${property}=${body[property]}`;
                        }
                    }
                }

                return {
                    url: url,
                    method: "GET",
                };
            },
        }),

        addNoteTypes: builder.mutation({
            query: (body) => ({
                url: `v1/${locale}/settings/note-types`,
                method: "POST",
                body: body,
            }),
        }),

        deleteNoteTypes: builder.mutation({
            query: (noteTypesId) => ({
                url: `v1/${locale}/settings/note-types/${noteTypesId}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const { useNoteTypesListMutation, useDeleteNoteTypesMutation, useAddNoteTypesMutation } = noteTypesManagement;
